<style lang="scss">
.ant-upload-list-item-card-actions.picture {
  line-height: 0;
  margin-right: 10px;
  top: 23px;
  // background-image: url("../../assets/icons/trash.svg");
}
.ant-upload-list-item-card-actions .anticon {
  //  color: red;
  line-height: 0;
}
.preview-image {
  .ant-modal {
    width: auto !important;
  }

  .ant-modal-close {
    outline: unset !important;
  }

  .ant-modal-close-x {
    line-height: 30px;
    width: 30px;
    outline: unset !important;
    display: none;
  }
  .ant-modal-body {
    width: 100%;
    padding: 0;
    max-width: 1080px;
    max-height: calc(100% - 40px);
  }
}
@media screen and (max-width: 320px) {
  .date-pk span.required {
    font-size: 11.2px;
  }
}
.btn-ecs-upload {
  background: #f8f8f8;
  border: 1px solid #ededed;
  border-radius: 20px;

  & > img {
    margin-right: 10px;
  }
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 740px) {
  .save-info {
    margin-right: 0 !important;
    padding: 7px !important;
    width: 100%;
  }
  .cancel-btn {
    background-color: #ececec;
    color: #6f6f6f;
  }
  .mobile-input {
    margin-top: 20px;
  }
  .form-data {
    margin-top: 20px;
  }
  .padding-mobile {
    padding: 0 !important;
  }
  .mobile-header {
    margin-bottom: 0;
  }
}
.form-control-file {
  overflow: hidden;
}
.save-info {
  margin-right: 10px;
  background-color: #3d4cdc;
  color: #fff;
}
.footer-btn {
  border-radius: 10px;
  width: 210px;
  height: 40px;
  font-weight: 700;
  font-size: 14px;
}

label {
  font-weight: 600;
}

.input-group {
  margin-bottom: 0px !important;
}

.row {
  margin-bottom: 20px;
}

.cancel-btn {
  padding: 7px 45px;
  font-weight: 600;
  background: #ececec;
  border: 2px solid #ececec;
  color: #6f6f6f;
}

span.require {
  color: #ff1a1a;
}

span.required {
  color: #ff1a1a;
  margin-top: -15px;
}

.form-data {
  text-align: center;
}
.image-evidence {
  max-width: 90%;
}
p.note {
  font-weight: 700;
  color: #ff1a1a;
}
</style>

<template>
  <div>
    <ValidationObserver ref="formAdditionalTimeSheet" v-slot="{ handleSubmit }">
      <CForm
        class="create_form"
        @submit.prevent="handleSubmit(registerOverTimeRequest)"
      >
        <CRow>
          <CCol md="12" class="form-field">
            <label>
              {{ $t("fields.additional_timeSheet.request_date") }}
              <span class="require">*</span>
            </label>
            <DatePickerTimeSheet
              id="error-mobile"
              :propsDate="forms.work_date"
              v-on:emitDate="workDateData"
              :rules="{
                required_date: true,
                before_or_equal_today: true,
              }"
              :name="'additional_timeSheet.request_date'"
            />
          </CCol>
        </CRow>
        <CRow>
          <CCol md="6" class="form-field">
            <label>
              {{ $t("fields.additional_timeSheet.admin") }}
              <span class="require">*</span>
            </label>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="additional_timeSheet.admin"
            >
              <select class="form-control" v-model="forms.admin_id">
                <option
                  v-for="(option, index) in dataCreateForm.admin"
                  :key="index"
                  :value="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
              <span class="required">{{ errors[0] }}</span>
            </ValidationProvider>
          </CCol>
          <CCol md="6" class="form-field mobile-input">
            <label>
              {{ $t("fields.additional_timeSheet.manager") }}
              <span class="require">*</span>
            </label>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="additional_timeSheet.manager"
            >
              <select class="form-control" v-model="forms.manager_id">
                <option
                  v-for="(option, index) in dataCreateForm.manager"
                  :key="index"
                  :value="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
              <span class="required">{{ errors[0] }}</span>
            </ValidationProvider>
          </CCol>
        </CRow>

        <CRow>
          <CCol md="6" class="form-field">
            <label>{{ $t("fields.additional_timeSheet.check_in_real") }}</label>
            <div class="form-control bg-text">
              {{ forms.start_time_real | formatHour }}
            </div>
          </CCol>
          <CCol md="6" class="form-field mobile-input">
            <label>
              {{ $t("fields.additional_timeSheet.check_in_request") }}
              <span class="require">*</span>
            </label>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="additional_timeSheet.check_in_request"
            >
              <b-form-input
                type="text"
                v-model="forms.start_time_request"
                v-mask="'##:##'"
                placeholder="HH:mm"
              />
              <span class="required">{{ errors[0] }}</span>
            </ValidationProvider>
          </CCol>
        </CRow>

        <CRow>
          <CCol md="6" class="form-field">
            <label>{{
              $t("fields.additional_timeSheet.check_out_real")
            }}</label>
            <div class="form-control bg-text">
              {{ forms.end_time_real | formatHour }}
            </div>
          </CCol>
          <CCol md="6" class="form-field mobile-input">
            <label>
              {{ $t("fields.additional_timeSheet.check_out_request") }}
              <span class="require">*</span>
            </label>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="additional_timeSheet.check_out_request"
            >
              <b-form-input
                type="text"
                v-model="forms.end_time_request"
                v-mask="'##:##'"
                placeholder="HH:mm"
              />
              <span class="required">{{ errors[0] }}</span>
            </ValidationProvider>
          </CCol>
        </CRow>
        <CRow>
          <CCol md="12" class="form-field">
            <label>{{ $t("fields.additional_timeSheet.evidence") }}</label>
            <span class="require"> *</span><br />
            <a-upload
              :file-list="fileList"
              :multiple="true"
              @preview="handlePreview"
              list-type="picture"
              :beforeUpload="beforeImageUpload"
              @change="handeImageChange"
            >
              <a-button class="btn-ecs-upload">
                <img src="../../assets/icons/file.svg" alt="" />
                Chọn ảnh
              </a-button>
              <br /><span class="require">{{ uploadImageMessage }}</span>
            </a-upload>
            <a-modal
              :zIndex="1030"
              centered
              class="preview-image"
              :visible="previewVisible"
              :footer="null"
              @cancel="handleCancelPreview"
            >
              <img
                alt="preview"
                style="width: 100%; aspect-ratio: initial"
                :src="previewImage"
              />
            </a-modal>
          </CCol>
        </CRow>
        <CRow>
          <CCol md="12" class="form-field">
            <label>
              {{ $t("fields.additional_timeSheet.reason") }}
              <span class="require">*</span>
            </label>
            <ValidationProvider
              rules="required|max:512"
              v-slot="{ errors }"
              name="additional_timeSheet.reason"
            >
              <b-form-textarea
                id="textarea"
                v-model="forms.reason"
                rows="5"
                max-rows="6"
                maxlength="255"
              ></b-form-textarea>
              <span class="required">{{ errors[0] }}</span>
            </ValidationProvider>
          </CCol>
        </CRow>
        <CRow>
          <CCol md="12" class="form-data">
            <CButton type="submit" class="save-info footer-btn">
              {{ $t("label.save_infomation") }}
            </CButton>
            <CButton
              class="cancel-btn footer-btn"
              type="button"
              @click="showModalConfirmCancel"
              >Hủy bỏ</CButton
            >
          </CCol>
        </CRow>
      </CForm>
    </ValidationObserver>
    <a-modal
      v-model="visible"
      title="Xác nhận hủy chỉnh sửa công"
      :centered="true"
      :footer="null"
      :width="684"
      :zIndex="1030"
    >
      <div class="remove-ot-request">
        <div class="content">
          <img src="../../assets/icons/note.svg" alt="" />
          <p>Bạn có chắc chắn thực hiện hành động này không ?</p>
        </div>

        <CRow class="form-button">
          <CCol md="12" class="employees-form-ot">
            <CButton type="submit" class="save-info" @click="handleCancel()"
              >Xác nhận
            </CButton>
            <CButton
              class="cancel-employee"
              type="button"
              @click="hideModalConfirmCancel()"
              >Ở lại trang
            </CButton>
          </CCol>
        </CRow>
      </div>
    </a-modal>
    <CusModal
      @handleCancel="hideErrorConfirm"
      @handleOk="hideErrorConfirm"
      :title="$t('popup.commons.label_popup_error')"
      :showCancelBtn="false"
      :isShow="errorModal"
    >
      <div class="text-center">
        <div class="warning-title">
          <img src="/img/icons/warning-icon.svg" alt="" />
          {{ $t("popup.commons.label_error_empty_manager") }}
        </div>
      </div>
    </CusModal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters } from "vuex";
import moment from "moment";
import DatePickerTimeSheet from "@/components/commons/DatePickerTimeSheet";
import CusModal from "@/components/commons/CusModal.vue";

export default {
  name: "CreateAdditionalTimesheet",
  metaInfo() {
    return {
      title: this.$t("page_title.page_additional_timeSheet_create"),
      titleTemplate: "%s | " + this.$t("page_title.head_title"),
    };
  },
  props: {
    work_date: {
      type: String,
    },
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    DatePickerTimeSheet,
    CusModal,
  },
  computed: {
    ...mapGetters({
      dataCreateForm: "additional-timesheet/dataCommonAdditionalTimeSheet",
    }),
    workDate() {
      return this.forms.work_date;
    },
  },
  data() {
    return {
      visible: false,
      errorModal: false,
      errorFileMessage: "",
      imageType: [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/PNG",
        "image/JPG",
      ],
      fileList: [],
      uploadImageMessage: "",
      isImage: true,
      image_evidence: "",
      forms: {
        work_date: null,
        admin_id: "",
        start_time_real: "",
        end_time_real: "",
        end_time_request: "",
        start_time_request: "",
        reason: null,
        img_evidence: "",
      },
      previewVisible: false,
      previewImage: "",
    };
  },

  created() {
    this.getDataCreateForm();
    if (this.$route.params.work_date) {
      this.forms.work_date = this.$route.params.work_date;
      this.forms.start_time_request =
        this.$route.params.start_time_real !== ""
          ? this.$route.params.start_time_real
          : this.forms.start_time_request;
      this.forms.end_time_request =
        this.$route.params.end_time_real !== ""
          ? this.$route.params.end_time_real
          : this.forms.end_time_request;
    } else if (this.work_date) {
      this.forms.work_date = this.work_date;
    } else {
      this.forms.work_date = moment(new Date())
        .subtract(1, "days")
        .format("DD/MM/YYYY");
      // this.forms.work_date = work_date.subtract(1, "days");
    }
  },

  watch: {
    workDate() {
      this.getDataCreateForm();
    },
  },

  methods: {
    workDateData(data) {
      this.forms.work_date = data;
    },
    hideErrorConfirm() {
      this.handleCancel();
    },
    async registerOverTimeRequest() {
      if (this.fileList.length == 0) {
        this.uploadImageMessage =
          this.$t("additional_timeSheet.evidence") +
          " " +
          this.$t("error.require");
        return false;
      }
      this.$root.$loading.start();
      let formData = new FormData();
      for (let key in this.forms) {
        if (key === "img_evidence") {
          if (this.fileList.length > 0) {
            this.fileList.forEach((file) => {
              formData.append("img_evidence[]", file.originFileObj);
            });
          }
        } else {
          formData.append(key, this.forms[key]);
        }
      }
      await this.$store
        .dispatch("additional-timesheet/registerAdditionalTimeSheet", formData)
        .then(() => {
          let message = this.$t("overtime.message_create_success");
          this.$toast(message, null, 2000, "b-toaster-top-center", "success");
          this.$store.dispatch("commons/getCountRequest");
          this.$root.$loading.finish();
          this.$emit("ok");
        })
        .catch(() => {
          this.$root.$loading.finish();
        });
    },
    handeImageChange(info) {
      this.uploadImageMessage = "";
      if (info.fileList.length > 2) {
        this.uploadImageMessage = "Upload tối đa 2 ảnh";
        return;
      }
      this.fileList = [];
      info.fileList.forEach((fileInfo) => {
        if (fileInfo.size > 2000000) {
          this.uploadImageMessage = this.$t("error.img_max");
          return;
        }
        if (this.imageType.includes(fileInfo.type)) {
          this.fileList.push(fileInfo);
        } else {
          this.uploadImageMessage = "Chỉ hỗ trợ định dạng .png, .jpg, .jpeg";
          return;
        }
      });
    },
    beforeImageUpload() {
      return false;
    },

    async getDataCreateForm() {
      // this.forms.end_time_request = "17:30";
      let date = moment(this.forms.work_date, "DD/MM/YYYY", true);
      if (date.isValid()) {
        this.$root.$loading.start();
        await this.$store.dispatch(
          "additional-timesheet/commonAdditionalTimeSheet",
          { work_date: this.forms.work_date }
        );
        if (
          this.dataCreateForm.manager.length === 0 ||
          this.dataCreateForm.admin.length === 0
        ) {
          this.errorModal = true;
          this.$root.$loading.finish();
          return;
        }
        let start_time_real =
          this.dataCreateForm.timeSheet !== null
            ? this.dataCreateForm.timeSheet.start_time_real
            : "";
        let end_time_real =
          this.dataCreateForm.timeSheet !== null
            ? this.dataCreateForm.timeSheet.end_time_real
            : "";
        this.forms.start_time_real =
          start_time_real !== null ? start_time_real : "";
        this.forms.end_time_real = end_time_real !== null ? end_time_real : "";
        // this.forms.start_time_request =
        //   this.forms.start_time_real <= this.forms.start_time_request &&
        //   this.forms.start_time_real != ""
        //     ? this.forms.start_time_real
        //     : this.forms.start_time_request;
        // this.forms.end_time_request =
        //   this.forms.end_time_real >= this.forms.end_time_request &&
        //   this.forms.end_time_real != ""
        //     ? this.forms.end_time_real
        //     : this.forms.end_time_request;
        this.forms.start_time_request = this.forms.start_time_real || "08:00";
        this.forms.end_time_request = this.forms.end_time_real || "17:30";
        let keyRandom = Math.floor(
          Math.random() * this.dataCreateForm.admin.length
        );
        this.forms.admin_id = this.dataCreateForm.admin[keyRandom]?.id;
        this.forms.manager_id = this.dataCreateForm.manager[keyRandom]?.id;
        this.$root.$loading.finish();
      }
    },
    showModalConfirmCancel() {
      this.visible = true;
    },

    hideModalConfirmCancel() {
      this.visible = false;
    },
    handleCancel() {
      this.$emit("cancel");
    },
    cancel() {
      this.$confirmModal(
        this.$t("popup.commons.label_popup_title"),
        this.$t("popup.commons.label_cancel_create"),
        this.$t("popup.commons.label_confirm_button"),
        this.$t("popup.commons.label_cancel_button"),
        "danger"
      ).then((value) => {
        if (value) {
          this.$emit("cancel");
        }
      });
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    handleCancelPreview() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
  },
};
</script>
